import React, { FC } from 'react'
import RepListContainer from 'containers/Rep/RepList'

const RepListPage: FC = () => <RepListContainer />

export default RepListPage
